<script setup>
import { defineProps, defineEmits, watch, ref, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";
import UtilNumber from "@/utils/UtilNumber";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "modalStatus",
    "contasFinanceiras",
    "dado",
    "adiantamento",
]);

const emits = defineEmits([
    "update:alteraAdiantamento",
]);

//==================================================================//
//====================== REF Job Parcela ===========================//
//==================================================================//

const refJobParcela = ref("");

//==================================================================//
//==================== REF Conta Financeira ========================//
//==================================================================//

const refContaFinanceira = ref("");

//==================================================================//
//======================= Altera Adiantamento ======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

//==================================================================//
//=================== Desativa Job Parcela ========================//
//==================================================================//

const desativaJobParcela = computed(()=>{

    if(props.controlesDesativados){
        return true;
    }

    return false;

});

//==================================================================//
//================= Desativa Conta Financeira ======================//
//==================================================================//

const desativaContaFinanceira = computed(()=>{

    if(props.controlesDesativados){
        return true;
    }

    return false;

});

//==================================================================//
//================== Desativa Valor Original =======================//
//==================================================================//

const desativaValorOriginal = computed(()=>{

    if(props.controlesDesativados){
        return true;
    }

    if(!props?.adiantamento?.jobParcela?.id){
        return true;
    }

    return false;

});

//==================================================================//
//==================== Valor Original Regras =======================//
//==================================================================//

const valorOriginalRegras = [
    valorOriginal =>{

        valorOriginal = UtilNumber.toNumber(valorOriginal);

        // Se Valor Original menor ou Igual a Zero
        if(valorOriginal <= 0){
            return false;
        }

        // Se Valor Original maior que o Valor para Receber de Job Parcela
        if(valorOriginal > props?.adiantamento?.jobParcela?.valorParaReceber){
            return false;
        }

        return UtilNumber.isNumber(valorOriginal);
    }
]

//==================================================================//
//==================== Ao Selecionar Job Parcela ===================//
//==================================================================//

const aoSelecionarJobParcela = (jobParcela={})=>{

    alteraAdiantamento({
        jobParcela: jobParcela || {},
        valorOriginal: jobParcela?.valorParaReceber
    })

};

//==================================================================//
//================= Ao Selecionar Conta Financeira =================//
//==================================================================//

const aoSelecionarContaFinanceira = (contaFinanceira={})=>{

    alteraAdiantamento({
        contaFinanceira: contaFinanceira || {},
    })

};

//==================================================================//
//================ Ao Alterar Valor Original =======================//
//==================================================================//

const aoAlterarValorOriginal = (valorOriginal = 0)=>{

    alteraAdiantamento({
        valorOriginal: UtilNumber.toNumber(valorOriginal) || 0,
    });

};

//==================================================================//
//==================== Watch => modalStatus ========================//
//==================================================================//

watch(()=> props.modalStatus, () => {

    if(props.modalStatus == false){

        refJobParcela.value.reset();
        refContaFinanceira.value.reset();

    }

});

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__header">

            <h3 class="c-header__titulo">

                Adiantamento - Job {{ props?.dado?.codigo }}

            </h3>

        </v-card-title>

        <v-divider></v-divider>

        <div class="c-cartao__body">

            <div class="c-campos c-campos--grid-fit-columns">

                <v-autocomplete
                    ref="refJobParcela"
                    label="Parcela do Job"
                    :items="props?.dado?.parcelas"
                    :disabled="desativaJobParcela"
                    outlined
                    clearable
                    return-object
                    hide-details
                    item-text="codigo"
                    @change="aoSelecionarJobParcela"
                >
            
                    <template v-slot:item="{ item }">
                        <span> <strong>{{item.codigo}}</strong> - <strong>{{item.tipo}}</strong> - <span>{{item.descricao}}</span> </span>
                    </template>

                    <template v-slot:selection="{ item }">
                        <span> <strong>{{item.codigo}}</strong> - <strong>{{item.tipo}}</strong> - <span>{{item.descricao}}</span> </span>
                    </template>
            
                </v-autocomplete>

            </div>

            <v-divider></v-divider>

                <div class="c-campos c-campos--grid-fit-columns">

                    <v-text-field class="c-campo__input"
                        label="Valor Original"
                        :value="UtilMoney.toR$BRL(props?.adiantamento?.jobParcela?.valorOriginal)"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Valor Liquidado"
                        :value="UtilMoney.toR$BRL(props?.adiantamento?.jobParcela?.valorRecebido)"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Valor a Liquidar"
                        :value="UtilMoney.toR$BRL(props?.adiantamento?.jobParcela?.valorParaReceber)"
                        disabled
                        outlined
                        return-object
                        hide-details
                    ></v-text-field>

                </div>

            <v-divider></v-divider>

            <div class="c-campos c-campos--grid-fit-columns">

                <v-autocomplete
                    ref="refContaFinanceira"
                    label="Conta Financeira"
                    :items="props?.contasFinanceiras"
                    :disabled="desativaContaFinanceira"
                    outlined
                    clearable
                    return-object
                    hide-details
                    item-text="nome"
                    @change="aoSelecionarContaFinanceira"
                >
            
                    <template v-slot:item="{ item }">
                        <span>{{item.nome}}</span>
                    </template>

                    <template v-slot:selection="{ item }">
                        <span>{{item.nome}}</span>
                    </template>
            
                </v-autocomplete>

                <vuetify-money
                    class="c-money"
                    type="number"
                    label="Valor Original"
                    outlined
                    :value="props?.adiantamento?.valorOriginal"
                    :disabled="desativaValorOriginal"
                    :rules="valorOriginalRegras"
                    hide-details
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                    @input="aoAlterarValorOriginal"
                ></vuetify-money>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

/*==================================================================*/
/*========================== Cartão ================================*/
/*==================================================================*/

.c-cartao__header{
    display: grid; 
    grid-template-columns: 1fr max-content; 
    grid-template-rows: max-content max-content; 
    gap: 10px; 
    grid-template-areas: 
        "titulo controles"
        "medidores medidores";
}

.c-header__titulo {
    grid-area: titulo;
}

.c-header__controles {
    grid-area: controles;
}

.c-header__medidores{
    grid-area: medidores;
}

.c-cartao__body{
    display: grid;
    grid-gap: 15px;
}

/*==================================================================*/
/*========================= Medidores ==============================*/
/*==================================================================*/

.c-medidores{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/*==================================================================*/
/*========================== Campos ================================*/
/*==================================================================*/

.c-campos--flex{
    display: flex;
}

.c-campos--grid-fit-columns{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 20px;
}

</style>